
(() => {
class StellaDinersPlanHub extends HTMLElement {
  connectedCallback() {
    this.forms = Array.from(this.querySelectorAll('[data-stella-consent-form]'));
    this.pageShowHandler ||= () => { this.resetForms(); this.applySelectedPlan(); };
    this.planNavigationHandler ||= () => this.applySelectedPlan();
    this.planClickHandler ||= (event) => {
      const change = event.target.closest('[data-stella-change-plan]');
      const choice = event.target.closest('[data-stella-select-plan]');
      if ((!change && !choice) || this.submitting || window.StellaCartState?.busy) return;
      const options = this.querySelector('[data-stella-plan-options]');
      if (change) {
        options.hidden = !options.hidden;
        change.setAttribute('aria-expanded', String(!options.hidden));
        return;
      }
      const plan = choice.dataset.stellaSelectPlan;
      if (!['monthly', 'annual'].includes(plan)) return;
      const url = new URL(window.location.href);
      url.searchParams.set('stella_plan', plan);
      window.history.pushState(null, '', url);
      this.applySelectedPlan();
      this.querySelector('[data-stella-change-plan]')?.focus();
    };
    this.removeEventListener('click', this.planClickHandler);
    this.addEventListener('click', this.planClickHandler);
    window.removeEventListener('popstate', this.planNavigationHandler);
    window.addEventListener('popstate', this.planNavigationHandler);

    this.forms.forEach((form) => {
      this.hydrateForm(form);
      if (form.dataset.stellaHandlerReady !== 'true') {
        form.addEventListener('submit', (event) => this.submitPlan(event, form));
        form.dataset.stellaHandlerReady = 'true';
      }
    });

    window.removeEventListener('pageshow', this.pageShowHandler);
    window.addEventListener('pageshow', this.pageShowHandler);
    this.resetForms();
    this.applySelectedPlan();
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.pageShowHandler);
    window.removeEventListener('popstate', this.planNavigationHandler);
    this.removeEventListener('click', this.planClickHandler);
  }

  applySelectedPlan() {
    const value = new URL(window.location.href).searchParams.get('stella_plan');
    const plan = ['monthly', 'annual'].includes(value) ? value : null;
    const summary = this.querySelector('[data-stella-plan-selection]');
    const lead = this.querySelector('.diners-plan-hub__lead');
    const intro = this.querySelector('.diners-plan-hub__intro');
    if (!summary || !lead || !intro) return;
    this.originalLead ??= lead.textContent;
    this.originalIntro ??= intro.textContent;
    const label = plan ? this.dataset[plan + 'SelectedLabel'] : '';
    if (plan) this.dataset.selectedPlan = plan;
    else delete this.dataset.selectedPlan;
    summary.hidden = !plan;
    this.querySelector('[data-stella-selected-plan]').textContent = label;
    this.querySelector('[data-stella-plan-options]').hidden = true;
    this.querySelector('[data-stella-change-plan]').setAttribute('aria-expanded', 'false');
    lead.textContent = plan ? label : this.originalLead;
    intro.textContent = plan ? this.dataset.selectedIntro : this.originalIntro;
    this.forms.forEach((form) => {
      form.closest('.diners-plan-card').hidden = !!plan && form.dataset.stellaConsentForm !== plan;
    });
    this.querySelectorAll('[data-stella-select-plan]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.stellaSelectPlan === plan));
    });
  }

  hydrateForm(form) {
    const values = {
      id: form.dataset.variantId,
      quantity: '1',
      selling_plan: form.dataset.sellingPlanId,
      'properties[_stella_membership_plan]': 'PREMIUM',
      'properties[_stella_campaign_code]': 'DINERS_PREMIUM_2026',
      'properties[_stella_campaign_benefit]': form.dataset.benefit,
      'properties[_stella_billing_cadence]': form.dataset.cadence,
      'properties[_stella_terms_version]': '2026-09-25',
      return_to: '/cart'
    };

    Object.entries(values).forEach(([name, value]) => {
      const field = form.elements.namedItem(name);
      if (field && 'value' in field) field.value = value;
    });
  }

  resetForms() {
    this.submitting = false;
    this.forms?.forEach((form) => {
      form.dataset.submitting = 'false';
      this.hydrateForm(form);
      const button = form.querySelector('button[type="submit"]');
      const label = form.querySelector('[data-stella-button-label]');
      const status = form.querySelector('[data-stella-status]');
      const cartLink = form.querySelector('[data-stella-cart-link]');

      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      if (label?.dataset.originalLabel) label.textContent = label.dataset.originalLabel;
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }
      if (cartLink) {
        cartLink.dataset.originalLabel ||= cartLink.textContent;
        cartLink.textContent = cartLink.dataset.originalLabel;
        cartLink.href = (window.Shopify?.routes?.root || '/') + 'cart';
        cartLink.hidden = true;
      }
    });
  }

  async submitPlan(event, form) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const now = Date.now();
    if (now < Date.parse('2026-10-09T00:00:00+09:00') || now >= Date.parse('2026-12-01T00:00:00+09:00')) {
      const status = form.querySelector('[data-stella-status]');
      if (status) { status.textContent = this.dataset.intakeClosedLabel; status.hidden = false; }
      return;
    }
    if (this.submitting || form.dataset.submitting === 'true') return;
    if (!form.reportValidity() || window.StellaCartState?.busy) return;
    const generation = this.generation;
    const release = window.StellaCartState?.acquire(this.forms.flatMap(current => [...current.querySelectorAll('button[type="submit"]')])) || (() => {});

    this.hydrateForm(form);
    const consentedAt = form.querySelector('[data-stella-consented-at]');
    if (consentedAt) consentedAt.value = new Date().toISOString();

    const button = form.querySelector('button[type="submit"]');
    const label = form.querySelector('[data-stella-button-label]');
    const status = form.querySelector('[data-stella-status]');
    const cartLink = form.querySelector('[data-stella-cart-link]');
    const root = window.Shopify?.routes?.root || '/';
    const variantId = Number(form.dataset.variantId);
    const sellingPlanId = String(form.dataset.sellingPlanId);

    if (label && !label.dataset.originalLabel) label.dataset.originalLabel = label.textContent.trim();
    this.submitting = true;
    form.dataset.submitting = 'true';
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    if (label) label.textContent = this.dataset.addingLabel;
    if (status) status.hidden = true;
    if (cartLink) {
      cartLink.dataset.originalLabel ||= cartLink.textContent;
      cartLink.textContent = cartLink.dataset.originalLabel;
      cartLink.href = root + 'cart';
      cartLink.hidden = true;
    }

    const data = new FormData(form);
    const properties = {};
    for (const [name, value] of data.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }

    try {
      if (!this.hasConfirmedConsent(properties)) throw new Error('cart_verification_failed');
      const before = await this.fetchCart(root);
      if (this.hasOtherMembershipPlan(before, variantId)) throw new Error('different_plan_in_cart');
      const selected = this.getSelectedPlan(before, variantId, sellingPlanId, true);
      const expectedProperties = { ...(selected?.properties || {}), ...properties };

      if (selected) {
        if (typeof selected.key !== 'string' || !selected.key) throw new Error('cart_verification_failed');
        const response = await this.request(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: selected.key,
            quantity: 1,
            properties: expectedProperties
          })
        });
        if (!response.ok) throw await this.rejectionError(response, 'cart_change_failed');
      } else {
        const response = await this.request(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              selling_plan: Number(sellingPlanId),
              properties: expectedProperties
            }]
          })
        });

        if (!response.ok) throw await this.rejectionError(response, 'cart_add_failed');
      }

      const cart = await this.fetchCart(root);
      if (this.hasOtherMembershipPlan(cart, variantId)) throw new Error('different_plan_in_cart');
      const saved = this.getSelectedPlan(cart, variantId, sellingPlanId);
      if (!saved || !this.hasConfirmedConsent(saved.properties) ||
          !Object.entries(expectedProperties).every(([name, value]) => saved.properties?.[name] === value)) {
        throw new Error('cart_verification_failed');
      }

      if (generation !== this.generation) return;
      window.location.assign(root + 'cart?stella_plan=' + encodeURIComponent(form.dataset.stellaConsentForm));
    } catch (error) {
      if (generation !== this.generation || error.message === 'cart_request_cancelled') return;
      this.submitting = false;
      form.dataset.submitting = 'false';
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      if (label?.dataset.originalLabel) label.textContent = label.dataset.originalLabel;
      const membershipNotice = this.membershipNotice(error.userMessage);
      if (status) {
        status.textContent = membershipNotice?.message || (error instanceof Error && error.message === 'different_plan_in_cart'
          ? this.dataset.conflictLabel
          : error.userMessage || this.dataset.errorLabel);
        status.hidden = false;
      }
      if (cartLink) {
        cartLink.hidden = false;
        if (membershipNotice) {
          cartLink.href = root + 'apps/stella-member/';
          cartLink.textContent = membershipNotice.label;
        }
      }
    } finally { release(); }
  }

  membershipNotice(message) {
    if (!message?.includes('有効な会員契約') && !message?.includes('入会手続き中')) return null;
    switch (this.dataset.memberStatus) {
      case 'ACTIVE': return { message: 'すでに会員登録済みです。ご契約内容はマイページでご確認ください。プラン変更をご希望の場合は、マイページからご相談いただけます。', label: 'ご契約内容を確認する' };
      case 'PAUSED': return { message: '現在、休会中のご契約があります。新たに申し込む必要はありません。マイページから復会をご相談ください。', label: '復会について相談する' };
      case 'APPLICANT': return { message: 'すでにお申し込みを受け付けています。マイページで手続きの進み具合を確認し、続きをお進めください。', label: 'お申し込みの続きへ' };
      default: return { message: 'ご登録済みの会員情報があるため、新規のお申し込みを停止しています。マイページでご契約・お申し込み状況をご確認ください。', label: '登録状況を確認する' };
    }
  }

  async rejectionError(response, code) {
    const data = await response.json();
    const error = new Error(code);
    error.userMessage = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : '';
    return error;
  }

  async request(url, options = {}) {
    if (!window.StellaCartState) throw new Error('cart_service_unavailable');
    return window.StellaCartState.request(url, options);
  }

  async fetchCart(root) {
    const response = await this.request(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('cart_fetch_failed');
    return response.json();
  }

  getSelectedPlan(cart, variantId, sellingPlanId, allowQuantityRepair = false) {
    if (!Array.isArray(cart?.items)) throw new Error('cart_verification_failed');
    const matches = cart.items.filter((item) => Number(item.variant_id) === variantId);
    if (matches.length === 0) return null;
    if (matches.length !== 1) throw new Error('cart_verification_failed');
    const item = matches[0];
    if (String(item.selling_plan_allocation?.selling_plan?.id) !== sellingPlanId) {
      throw new Error('different_plan_in_cart');
    }
    if (!Number.isInteger(Number(item.quantity)) || Number(item.quantity) < 1 || (!allowQuantityRepair && Number(item.quantity) !== 1)) throw new Error('cart_verification_failed');
    return item;
  }

  hasConfirmedConsent(properties) {
    return properties?._stella_membership_plan === 'PREMIUM' &&
      properties._stella_campaign_code === 'DINERS_PREMIUM_2026' &&
      properties._stella_adult_confirmed === 'yes' &&
      properties._stella_terms_accepted === 'yes' &&
      properties._stella_terms_version === '2026-09-25' &&
      (properties._stella_billing_cadence !== '月額' || properties._stella_recurring_price_confirmed === 'yes') &&
      typeof properties._stella_consented_at === 'string' &&
      Number.isFinite(Date.parse(properties._stella_consented_at));
  }

  hasOtherMembershipPlan(cart, variantId) {
    const campaignVariants = ['45564318580822', '45568395870294'];
    return Array.isArray(cart?.items) && cart.items.some((item) => {
      const isCampaignVariant = campaignVariants.includes(String(item.variant_id));
      const isPremiumMembership = item.properties?._stella_membership_plan === 'PREMIUM';
      return (isCampaignVariant || isPremiumMembership) && Number(item.variant_id) !== variantId;
    });
  }
}

if (!customElements.get('stella-diners-plan-hub-readable')) {
  customElements.define('stella-diners-plan-hub-readable', StellaDinersPlanHub);
}
})();

